import * as React from "react";
import { IFaqQuestion } from "../../models/IFaq";

interface IFaqQuestions {
    questions: IFaqQuestion[];
    populateModal: (faqId: number) => any;
}

export const FaqQuestions: React.FunctionComponent<IFaqQuestions> = ({ questions, populateModal }) => {
    return (
        <div>
            {
                questions.map((q, key) =>
                    <div key={key} className="row justify-content-md no-gutters">
                        <div className="col-md-auto">
                            <span className="dot" />
                        </div>
                        <div className="col">
                            <button
                                key={key}
                                type="button"
                                className="link-button text-wrap"
                                onClick={() => populateModal(q.id)}>
                                {q.question}
                            </button>
                        </div>
                    </div>)
            }
        </div>
    )
}